// extracted by mini-css-extract-plugin
export var action = "Conversation-module--action--UojoF";
export var info = "Conversation-module--info--zfFSP";
export var inner = "Conversation-module--inner--Uk63h";
export var intro = "Conversation-module--intro--5snNJ";
export var root = "Conversation-module--root--5dfXO";
export var share = "Conversation-module--share--8HJbv";
export var textWrapper = "Conversation-module--textWrapper--F9gCT";
export var videoWrapper = "Conversation-module--videoWrapper--k0FZR";
export var wrapper = "Conversation-module--wrapper--EQO61";